{
  "overview": {
    "title": "مركز قيادة البنية التحتية",
    "description": "إدارة الحوسبة السيادية وعناقيد البيانات الموزعة وشبكة الاتصال الوطنية. حوكمة الشبكة على مستوى مؤسسي.",
    "system": "CORE_INFRA",
    "badge": "العمود الفقري نشط",
    "deep_scan": "الفحص العميق نشط",
    "initiate_audit": "بدء التدقيق",
    "system_health": "صحة النظام",
    "uptime": "وقت التشغيل",
    "compute_load": "حمل الحوسبة",
    "threat_level": "مستوى التهديد",
    "database_clusters": "شبكة البيانات الموزعة",
    "database_clusters_desc": "محرك مزامنة بيانات من الفئة المؤسسية للعناقيد السيادية.",
    "sync_status": "حالة المزامنة",
    "global_iops": "IOPS العالمي",
    "cluster_count": "عدد العناقيد",
    "nominal": "طبيعي",
    "cyber_command": "القيادة السيبرانية",
    "cyber_command_desc": "نظام دفاع متعدد الطبقات في الوقت الفعلي مع تخفيف التهديدات الآلية.",
    "encryption": "التشفير",
    "active_guards": "الحراس النشطون",
    "mesh_connectivity": "اتصال الشبكة",
    "mesh_connectivity_desc": "توجيه العمود الفقري عالي الأداء عبر الشبكة السيادية.",
    "global_latency": "زمن الاستجابة العالمي",
    "throughput": "معدل النقل",
    "edge_nodes": "عقد الحافة",
    "identity_matrix": "مصفوفة الهوية (CRM)",
    "identity_matrix_desc": "محرك إدارة العلاقات العميق مع التحكم في الوصول المؤسسي.",
    "registry_size": "حجم السجل",
    "kyc_verified": "تم التحقق من KYC",
    "auth_success": "نجاح المصادقة",
    "continuity_engine": "محرك الاستمرارية",
    "continuity_engine_desc": "نظام النسخ الاحتياطي الجغرافي المتكرر مع النسخ المتماثل دون المللي ثانية.",
    "dr_readiness": "جاهزية التعافي من الكوارث",
    "sync_drift": "انجراف المزامنة",
    "cold_storage": "التخزين البارد",
    "certified": "معتمد",
    "active": "نشط",
    "core_telemetry": "القياس عن بُعد الأساسي",
    "hardware_pulse": "نبض الأجهزة",
    "configure_grid": "تهيئة الشبكة",
    "aggregate_performance": "الأداء الإجمالي",
    "realtime_balancing": "موازنة الحمل في الوقت الفعلي",
    "window_24h": "نافذة 24 ساعة",
    "live_monitoring": "المراقبة المباشرة",
    "timeline_24h": "الجدول الزمني T-24H",
    "incident_command_log": "سجل أوامر الحوادث",
    "forensic_telemetry": "القياس الجنائي عن بُعد",
    "archives": "الأرشيف",
    "secure_session": "جلسة آمنة • شريكاتي السيادية",
    "warning": "تحذير",
    "neural_compute_load": "حمل الحوسبة العصبية",
    "matrix_memory": "ذاكرة المصفوفة",
    "io_flux": "تدفق الإدخال/الإخراج",
    "command_view": "عرض القيادة",
    "status_nominal": "طبيعي",
    "status_warning": "تحذير"
  },
  "security": {
    "title": "الأمن السيادي",
    "description": "مراقبة المحيط على مستوى وزاري والتدقيق الجنائي في الوقت الفعلي.",
    "system": "SECURITY_OPS",
    "audit_flow": "تدفق التدقيق",
    "stress_test": "اختبار الضغط",
    "threat_surface": "سطح التهديد",
    "aggregated_risk_exposure": "التعرض للمخاطر الإجمالية",
    "cryptographic_load": "حمل التشفير",
    "hsm_cluster_capacity": "سعة عنقود HSM",
    "vault_sync_status": "حالة مزامنة الخزنة",
    "multi_zone_consistency": "التوافق متعدد المناطق",
    "identity_trust": "ثقة الهوية",
    "biometric_zero_trust": "القياسات الحيوية والثقة الصفرية",
    "tabs": {
      "overview": "نظرة عامة",
      "encryption": "التشفير",
      "access": "الوصول",
      "logs": "السجلات"
    },
    "realtime_forensic_feed": "التغذية الجنائية في الوقت الفعلي",
    "institutional_audit": "التدقيق المؤسسي",
    "live_transaction_stream": "دفق المعاملات المباشر",
    "system_live": "النظام_مباشر",
    "nodes_checked": "العقد المفحوصة: 100%",
    "trust_index": "مؤشر الثقة",
    "perimeter_grid": "شبكة المحيط",
    "ministerial_surveillance": "المراقبة الوزارية",
    "global_anomaly_vector": "متجه الشذوذ العالمي",
    "breach_identified": "تم_تحديد_الاختراق",
    "nominal_stable": "طبيعي_مستقر",
    "lock_high_gates": "قفل البوابات العالية",
    "cycle_perimeter": "دوران المحيط",
    "institutional_forensic_log": "سجل الجنائيات المؤسسي",
    "ministerial_access_system_traces": "الوصول الوزاري وآثار النظام",
    "master_archives": "الأرشيف الرئيسي",
    "view_trace": "عرض التتبع",
    "entropy_optimization": "تحسين الإنتروبيا",
    "multi_source_randomness_generation": "توليد العشوائية متعددة المصادر",
    "master_key_rotation_verified": "تم التحقق من دوران المفتاح الرئيسي",
    "sources": {
      "a": "المصدر أ (HSM)",
      "b": "المصدر ب (كمي)",
      "c": "المصدر ج (العمود الفقري)",
      "aggregated": "المجمع"
    },
    "bits_h": "بت/ساعة",
    "module_archive": "أرشيف الوحدة",
    "scanning_sovereign_data_silos": "فحص صوامع البيانات السيادية للآثار التاريخية...",
    "access_control": "التحكم في الوصول",
    "sovereign_authority_matrix": "مصفوفة السلطة السيادية",
    "manage_authority": "إدارة السلطة",
    "policy_compliance": "الامتثال للسياسات",
    "gain": "كسب",
    "access_items": {
      "ministerial_access": "الوصول الوزاري",
      "cfo_master_key": "مفتاح CFO الرئيسي",
      "compliance_audit": "تدقيق الامتثال",
      "third_party_hubs": "محاور الأطراف الثالثة",
      "status_active": "نشط",
      "status_engaged": "مشغّل",
      "status_nominal": "طبيعي",
      "status_restricted": "مقيّد"
    },
    "vault_v4": "الخزنة_v4",
    "secure_sync": "مزامنة_آمنة",
    "aes_gcm": "AES-GCM-256",
    "key_count": "عدد المفاتيح",
    "integrity": "النزاهة",
    "hsm_module_locked": "وحدة HSM مقفلة",
    "sovereign_vault": "الخزنة السيادية: {{id}}",
    "hsm_id": "معرف HSM: {{id}}_ألفا",
    "integrity_verification": "التحقق من النزاهة:",
    "enforced_active": "مفعّل_نشط",
    "active_keys": "المفاتيح النشطة",
    "rotation_cycle": "دورة التدوير",
    "entropy_score": "درجة الإنتروبيا",
    "access_load": "حمل الوصول",
    "days_14": "14 يوماً",
    "key_matrix_archive": "أرشيف مصفوفة المفاتيح",
    "export_report": "تصدير التقرير",
    "class": "الفئة: {{type}}",
    "created": "تم الإنشاء: {{date}}",
    "active": "نشط",
    "rotate_master_keys": "تدوير المفاتيح الرئيسية",
    "run_forensic_audit": "تشغيل التدقيق الجنائي",
    "sovereign_integrity_sealed": "نزاهة سيادية مختومة",
    "charikaty_security_layer": "طبقة أمان شريكاتي",
    "system_user": "النظام",
    "categories": {
      "ACCESS": "الوصول",
      "TRANSACTION": "المعاملة",
      "ENCRYPTION": "التشفير",
      "THREAT": "التهديد",
      "SYSTEM": "النظام"
    },
    "tx_types": {
      "OUTBOUND": "صادر",
      "SWIFT": "سويفت",
      "INTERNAL": "داخلي"
    },
    "severities": {
      "low": "منخفض",
      "medium": "متوسط",
      "high": "عالٍ",
      "critical": "حرج"
    },
    "tx_statuses": {
      "approved": "موافق عليه",
      "flagged": "مُعلَّم",
      "blocked": "محجوب"
    }
  },
  "databases": {
    "title": "شبكة البيانات الموزعة",
    "description": "محرك مزامنة بيانات على مستوى مؤسسي لعناقيد البيانات القانونية والمالية السيادية. فرض التوافق الذري.",
    "system": "CORE_DATA_BACKBONE",
    "badge": "الشبكة المؤسسية نشطة",
    "global_sync": "مزامنة عالمية",
    "syncing": "جاري المزامنة...",
    "audit_lineage": "تدقيق الأصول",
    "metrics": {
      "distributed_traces": "آثار موزعة",
      "aggregated_records": "سجلات سيادية مجمعة",
      "network_throughput": "معدل نقل الشبكة",
      "replication_stream": "تدفق النسخ المتماثل في الوقت الفعلي",
      "hash_verification": "التحقق من الهاش",
      "no_anomalies": "لم يتم تحديد أي شذوذ",
      "crypto_layer": "طبقة التشفير",
      "module_encryption": "التشفير على مستوى الوحدة"
    },
    "clusters": {
      "legal": "المستودع القانوني",
      "financial": "دفتر الأستاذ المالي",
      "operational": "النواة السيادية",
      "offline": "غير متصل",
      "active": "الوحدة نشطة",
      "standby": "استعداد",
      "metrics_unavailable": "المقاييس غير متوفرة",
      "record_volume": "حجم السجلات",
      "integrity_level": "مستوى النزاهة",
      "alpha_7": "العنقود السيادي ألفا-7"
    },
    "topology": {
      "title": "طوبولوجيا الشبكة السيادية",
      "consensus": "الإجماع الإقليمي: نشط (Paxos-v4)",
      "latency": "زمن استجابة العنقود",
      "global_sync_locked": "المزامنة العالمية مقفلة"
    },
    "explorer": {
      "placeholder": "جاري فحص الفهرس الرئيسي لـ {{db}}...",
      "class_all": "الفئة: جميع المتجهات",
      "no_records": "لم يتم تحديد سجلات مطابقة",
      "grid_empty": "شبكة البيانات السيادية فارغة لهذا التحديد",
      "table": {
        "ref": "مرجع السجل الرئيسي",
        "entity": "الكيان السيادي / الأصول",
        "class": "فئة الأمن",
        "integrity": "متجه النزاهة",
        "value": "رسم خرائط القيم"
      }
    },
    "drawer": {
      "master_id": "المعرف الرئيسي: {{id}}",
      "system_hash": "هاش النظام:",
      "lifecycle": "مرحلة دورة الحياة",
      "asset_magnitude": "حجم الأصول",
      "classification": "مستوى التصنيف",
      "security_manifest": "بيان الأمن",
      "manifest_desc": "تصنيف البيانات السيادية",
      "vector_class": "تصنيف المتجه",
      "access_protocol": "بروتوكول الوصول",
      "metadata_matrix": "مصفوفة البيانات الوصفية الرئيسية",
      "edit_params": "تعديل المعلمات",
      "audit_view": "عرض التدقيق الكامل",
      "version_lineage": "تسلسل الإصدارات",
      "secure_handshake": "صافحة آمنة",
      "integrity_seal": "ختم النزاهة نشط",
      "aes_layer": "AES-256 متعدد الطبقات",
      "backbone": "العمود الفقري للبيانات السيادية",
      "market_normalized": "معدل السوق",
      "sensitivity_level": "مستوى الحساسية"
    },
    "flow": {
      "step": "الخطوة {{num}}",
      "replicating": "جاري النسخ المتماثل..."
    },
    "node_modal": {
      "title": "عقدة العنقود: {{id}}",
      "mesh_active": "شبكة {{region}} نشطة",
      "metrics": {
        "cpu": "حمل المعالج",
        "io": "إدخال/إخراج الشبكة",
        "storage": "التخزين المستخدم",
        "health": "مؤشر الصحة"
      },
      "thread_analytics": "تحليلات الخيوط النشطة",
      "nominal_flow": "تدفق طبيعي",
      "degraded": "أداء متراجع",
      "reboot": "إعادة تشغيل العنقود الآمن",
      "audit_storage": "تدقيق التخزين"
    },
    "audit_modal": {
      "title": "تدقيق تسلسل البيانات",
      "traceability": "التتبع الكامل مفعل",
      "export": "تصدير التدقيق (PDF)"
    },
    "terminal": {
      "title": "غلاف_تصحيح_السيادة",
      "init": "بدء الاتصال بالعمود الفقري العالمي...",
      "auth": "المصادقة: نجاح (الجذر السيادي)",
      "status_logs": "--- سجلات حالة النظام ---"
    }
  },
  "connectivity": {
    "title": "العمود الفقري العصبي",
    "description": "مراقبة الشبكة السيادية، تحسين الوصلات الصاعدة عالية الكثافة، وتنسيق طوبولوجيا المناطق العابرة.",
    "system": "BACKBONE_OPS",
    "actions": {
      "optimize": "تحسين الطوبولوجيا"
    },
    "metrics": {
      "latency": "ناقل الكمون",
      "latency_sla": "هدف اتفاقية مستوى الخدمة الوزاري: < 15 مللي ثانية",
      "uplink": "كثافة الوصلة الصاعدة",
      "uplink_desc": "مصافحات الأقران المتزامنة",
      "coverage": "تغطية الشبكة",
      "coverage_desc": "عناقيد معزولة جغرافياً",
      "uptime": "وقت تشغيل العمود الفقري",
      "uptime_desc": "حيوية النظام الأساسي"
    },
    "tabs": {
      "nodes": "البنية التحتية للحافة",
      "endpoints": "نقاط نهاية واجهة برمجة التطبيقات"
    },
    "search": "البحث في مصفوفة البنية التحتية...",
    "table": {
      "node_id": "معرف العقدة",
      "region": "المنطقة الجغرافية",
      "health": "ناقل الصحة",
      "telemetry": "القياس عن بعد",
      "perimeter": "المحيط",
      "grid_load": "حمل الشبكة",
      "endpoint_path": "مسار نقطة النهاية",
      "method": "الطريقة",
      "audit_status": "حالة التدقيق",
      "performance": "أداء P99",
      "total_calls": "{{count}} إجمالي المكالمات / ساعة",
      "error_rate": "معدل الخطأ:"
    },
    "topology": {
      "title": "طوبولوجيا الشبكة الديناميكية",
      "subtitle": "محرك تنسيق الحزم من الدرجة السيادية",
      "validated": "تم التحقق",
      "in_flight": "قيد النقل",
      "anycast": "أنيكاست",
      "global_wan": "شبكة WAN العالمية",
      "sovereign_gateway": "البوابة السيادية",
      "internal_clusters": "عناقيد البيانات الداخلية",
      "packet_audit": "تدقيق الحزم العميق",
      "stealth_flow": "تدفق متخفٍ تم التحقق منه",
      "stealth_desc": "مصافحات mTLS وHSM متقدمة عند كل نقطة دخول.",
      "mapping": "رسم خرائط الطوبولوجيا",
      "ai_grid": "شبكة محسنة بالذكاء الاصطناعي",
      "ai_grid_desc": "إعادة تكوين ديناميكية للمسارات بناءً على أنماط الحمل العصبية.",
      "resilience": "مرونة الأنيكاست",
      "failover": "تجاوز الفشل متعدد الطبقات",
      "failover_desc": "تبديل جغرافي بدون توقف مع تشتت نشط-نشط."
    },
    "vitality": {
      "title": "حيوية الشبكة",
      "subtitle": "مصفوفة المرونة السيادية",
      "bgp": "تقارب BGP",
      "anycast_nodes": "عقد الأنيكاست",
      "corruption": "فساد الحزم",
      "decay": "مؤشر تحلل الألياف",
      "aggregate_load": "إجمالي حمل الشبكة",
      "sync": "مزامنة عبر المناطق",
      "synchronized": "متزامن",
      "analysis": "تحليل الطوبولوجيا"
    },
    "feed": {
      "title": "التغذية المؤسسية",
      "subtitle": "بث جنائي مباشر للعمود الفقري",
      "streaming": "بث مباشر",
      "source_node": "عقدة المصدر:",
      "audit_verified": "تم التحقق من تدقيق الشبكة العصبية الإصدار 4.2"
    },
    "node_modal": {
      "protocol": "بروتوكول العقدة:",
      "backbone_zone": "منطقة العمود الفقري",
      "latency": "كمون الحافة",
      "load_index": "مؤشر حمل الشبكة",
      "health": "صحة الشبكة",
      "telemetry_title": "القياس عن بعد للموارد السيادية",
      "bandwidth": "عرض نطاق العمود الفقري",
      "memory": "ذاكرة عنقود العقدة",
      "transport": "بروتوكولات النقل الآمنة",
      "decommission": "إيقاف تشغيل العقدة",
      "initialize": "تهيئة العقدة",
      "parametrics": "مقاييس العقدة",
      "network_layer": "طبقة الشبكة السيادية"
    },
    "status": {
      "healthy": "سليم",
      "online": "متصل",
      "offline": "غير متصل",
      "warning": "تحذير",
      "critical": "حرج"
    }
  }
}
